import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useApi } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Reveal } from "@/components/site/Reveal";
import { RetreatCard } from "@/pages/Retreats";

export const UpcomingRetreats = () => {
  const { t, to } = useLang();
  const { data } = useApi("/retreats", []);
  if (!data.length) return null;
  return (
    <section className="container-x py-20 sm:py-24" data-testid="home-retreats">
      <Reveal className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <p className="eyebrow">{t("home.retreatsEyebrow")}</p>
          <h2 className="mt-3 text-4xl font-black tracking-tight text-forest sm:text-5xl">{t("home.retreatsTitle")}</h2>
        </div>
        <Link to={to("/retreats")} className="btn-outline" data-testid="home-retreats-view-all">{t("home.retreatsCta")} <ArrowRight className="h-4 w-4" /></Link>
      </Reveal>
      <div className="mt-12 grid gap-8 md:grid-cols-2">
        {data.slice(0, 2).map((r, i) => <Reveal key={r.slug} delay={i * 0.08}><RetreatCard r={r} /></Reveal>)}
      </div>
    </section>
  );
};
